import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class StarsResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("StarsResourcePackage");
    }
    public get assets_views_stars_stars_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/stars/stars_1x.atlas.json");
    }
    public get assets_views_stars_13_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["13.png"];
    }
    public get assets_views_stars_8_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["8.png"];
    }
    public get assets_views_stars_9_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["9.png"];
    }
    public get assets_views_stars_7_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["7.png"];
    }
    public get assets_views_stars_14_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["14.png"];
    }
    public get assets_views_stars_3_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["3.png"];
    }
    public get assets_views_stars_1_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["1.png"];
    }
    public get assets_views_stars_6_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["6.png"];
    }
    public get assets_views_stars_2_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["2.png"];
    }
    public get assets_views_stars_5_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["5.png"];
    }
    public get assets_views_stars_4_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["4.png"];
    }
    public get assets_views_stars_11_png(): Texture {
        return this.assets_views_stars_stars_1x_atlas_json.textures["11.png"];
    }
    public get assets_views_stars_stars_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/stars/stars_1x.atlas.png");
    }
}

